var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0391 17.4633C9.90573 17.4633 9.78906 17.4174 9.68906 17.3258C9.58906 17.2341 9.53906 17.1133 9.53906 16.9633V9.36328C9.53906 9.21328 9.58906 9.09245 9.68906 9.00078C9.78906 8.90911 9.90573 8.86328 10.0391 8.86328C10.0724 8.86328 10.1891 8.91328 10.3891 9.01328L14.0141 12.6383C14.0974 12.7216 14.1557 12.8049 14.1891 12.8883C14.2224 12.9716 14.2391 13.0633 14.2391 13.1633C14.2391 13.2633 14.2224 13.3549 14.1891 13.4383C14.1557 13.5216 14.0974 13.6049 14.0141 13.6883L10.3891 17.3133C10.3391 17.3633 10.2849 17.4008 10.2266 17.4258C10.1682 17.4508 10.1057 17.4633 10.0391 17.4633Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightRounded);
export default __webpack_public_path__ + "static/media/arrow-right-rounded.08ca26240ea5ab37233521ae5d91fbe3.svg";
export { ForwardRef as ReactComponent };